<div class="flex flex-col w-full max-h-[90vh] relative">

    <!-- Header -->
    <div class="flex items-center p-6 w-full relative flex-shrink-0">
        <div class="p-2 rounded-xl bg-amber-100 ml-2 w-[44px] h-[44px] flex items-center justify-center">
            <mat-icon svgIcon="mat_solid:warning" class="icon-size-6 text-amber-600"></mat-icon>
        </div>
        <div class="px-3">
            <div class="w-full leading-10">
                <span class="text-[24px] font-[600] font-remote">Armazenamento quase no limite</span>
            </div>
        </div>
        <div (click)="close()" class="mx-4 rounded-full hover:bg-gray-100 cursor-pointer absolute right-0 p-2 w-[44px] h-[44px] top-[20px]">
            <mat-icon class="text-gray-700 hover:text-gray-500 icon-size-7 right-0 relative" svgIcon="mat_solid:close"></mat-icon>
        </div>
    </div>

    <!-- Body -->
    <div class="w-full overflow-y-auto flex-1 min-h-0 px-4 pb-2">
        <div class="w-full p-4">
            <div class="w-full rounded-xl bg-amber-50 border border-amber-200 px-4 py-5 flex items-start gap-2.5 animate-fadeIn">
                <mat-icon class="icon-size-6 text-amber-600 flex-shrink-0 mt-0.5" svgIcon="mat_solid:storage"></mat-icon>
                <p class="font-inter font-[400] text-[14px] text-gray-700 leading-relaxed">
                    O armazenamento da igreja está prestes a alcançar o limite
                    (<span class="font-[600] text-amber-700">{{ usedPercent }}%</span> usado de
                    <span class="font-[600] text-amber-700">{{ planStorageGb }} GB</span>).
                    Para continuar enviando arquivos com tranquilidade, adquira armazenamento extra.
                </p>
            </div>
        </div>
    </div>

    <!-- Footer -->
    <div class="flex items-center justify-end gap-2 p-6 pt-4 flex-shrink-0">
        <button (click)="close()"
                class="flex items-center gap-2 px-5 py-2 rounded-3xl bg-[#0061ff] hover:bg-[#2f75e7] transition-colors cursor-pointer">
            <mat-icon class="icon-size-5 text-white" svgIcon="mat_solid:check"></mat-icon>
            <span class="font-remote font-[500] text-[14px] text-white">Entendi</span>
        </button>
    </div>
</div>